﻿import assets from 'assets'
import Mustache from 'mustache'
import jQuery from 'jquery'

(function ($) {
  $.mustache = function (template, view, partials) {
    return Mustache.render(template, view, partials)
  }

  $.fn.mustache = function (view, partials) {
    return $(this).map(function (i, elm) {
      var template = $.trim($(elm).html())
      var output = $.mustache(template, view, partials)
      return $(output).get()
    })
  }
}(jQuery))

function render (name, context) {
  return jQuery.mustache(assets.templates[name], context)
}

function normalizeText(text){
  var str = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  return str.replace(/[^a-zA-Z0-9 ]/g, "").toLowerCase()
}

const util = {
  render,
  normalizeText
}

export default util
